import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scroll to top on pathname change EXCEPT when only the /:lang prefix changes
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Strip language prefix for comparison
    const stripped = pathname.replace(/^\/(ar|en)/, "") || "/";
    const prev = window.__prevPath || null;
    window.__prevPath = stripped;

    if (prev !== null && prev === stripped) {
      // language-only change, do not scroll
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}
